import { COLOR } from "@xe/constants";
var darkMode = {
  listItem: {
    color: COLOR.white
  }
};
var lightMode = {
  listItem: {
    color: COLOR.grey1
  }
};
export default {
  darkMode: darkMode,
  lightMode: lightMode
};